import { bl_del_job_event_RowClass, bl_del_job_event_RowInterface } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class DelJobEventContainerModel extends BaseContainerModel {
  bl_del_job_event: bl_del_job_event_RowInterface = new bl_del_job_event_RowClass();
}